import styled from 'styled-components';

export const DivTable = styled.div`
  overflow: auto;
  max-width: 90vw;
`;
